// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/entity/person.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_entity_contact } from "./contact_pb";

/**
 * Describes the file proto/model/entity/person.proto.
 */
export const file_proto_model_entity_person = /*@__PURE__*/
  fileDesc("Ch9wcm90by9tb2RlbC9lbnRpdHkvcGVyc29uLnByb3RvEgZjYXJtZW4i8wIKBlBlcnNvbhISCgpnaXZlbl9uYW1lGAEgASgJEhMKC2ZhbWlseV9uYW1lGAIgASgJEhMKC21pZGRsZV9uYW1lGAMgASgJEhYKDnByZWZlcnJlZF9uYW1lGAQgASgJEg0KBXRpdGxlGAUgASgJEi4KCmJpcnRoX2RhdGUYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEh4KBmdlbmRlchgHIAEoDjIOLmNhcm1lbi5HZW5kZXISKQoMY29udGFjdF9pbmZvGAggASgLMhMuY2FybWVuLkNvbnRhY3RJbmZvEjQKEmlkZW50aXR5X2RvY3VtZW50cxgJIAMoCzIYLmNhcm1lbi5JZGVudGl0eURvY3VtZW50EjYKE2FjY2Vzc2liaWxpdHlfbmVlZHMYCiADKA4yGS5jYXJtZW4uQWNjZXNzaWJpbGl0eU5lZWQSGwoTcHJlZmVycmVkX2xhbmd1YWdlcxgLIAMoCSLJAQoQSWRlbnRpdHlEb2N1bWVudBIzCg1kb2N1bWVudF90eXBlGAEgASgOMhwuY2FybWVuLklkZW50aXR5RG9jdW1lbnRUeXBlEhcKD2RvY3VtZW50X251bWJlchgCIAEoCRIXCg9pc3N1aW5nX2NvdW50cnkYAyABKAkSMwoPZXhwaXJhdGlvbl9kYXRlGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIZChFpc3N1aW5nX2F1dGhvcml0eRgFIAEoCSJ4ChBNZWRpY2FsQ29uZGl0aW9uEhYKDmNvbmRpdGlvbl9uYW1lGAEgASgJEhAKCHNldmVyaXR5GAIgASgJEhwKFHJlcXVpcmVkX21lZGljYXRpb25zGAMgAygJEhwKFHNwZWNpYWxfaW5zdHJ1Y3Rpb25zGAQgAygJKnkKBkdlbmRlchIWChJHRU5ERVJfVU5TUEVDSUZJRUQQABIPCgtHRU5ERVJfTUFMRRABEhEKDUdFTkRFUl9GRU1BTEUQAhIVChFHRU5ERVJfTk9OX0JJTkFSWRADEhwKGEdFTkRFUl9QUkVGRVJfTk9UX1RPX1NBWRAEKt8BChRJZGVudGl0eURvY3VtZW50VHlwZRImCiJJREVOVElUWV9ET0NVTUVOVF9UWVBFX1VOU1BFQ0lGSUVEEAASIwofSURFTlRJVFlfRE9DVU1FTlRfVFlQRV9QQVNTUE9SVBABEioKJklERU5USVRZX0RPQ1VNRU5UX1RZUEVfRFJJVkVSU19MSUNFTlNFEAISJgoiSURFTlRJVFlfRE9DVU1FTlRfVFlQRV9OQVRJT05BTF9JRBADEiYKIklERU5USVRZX0RPQ1VNRU5UX1RZUEVfTUlMSVRBUllfSUQQBCqPAgoRQWNjZXNzaWJpbGl0eU5lZWQSIgoeQUNDRVNTSUJJTElUWV9ORUVEX1VOU1BFQ0lGSUVEEAASKAokQUNDRVNTSUJJTElUWV9ORUVEX1dIRUVMQ0hBSVJfQUNDRVNTEAESKgomQUNDRVNTSUJJTElUWV9ORUVEX01PQklMSVRZX0FTU0lTVEFOQ0UQAhIoCiRBQ0NFU1NJQklMSVRZX05FRURfVklTVUFMX0lNUEFJUk1FTlQQAxIpCiVBQ0NFU1NJQklMSVRZX05FRURfSEVBUklOR19JTVBBSVJNRU5UEAQSKwonQUNDRVNTSUJJTElUWV9ORUVEX0NPR05JVElWRV9BU1NJU1RBTkNFEAVCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw", [file_google_protobuf_timestamp, file_proto_model_entity_contact]);

/**
 * Describes the message carmen.Person.
 * Use `create(PersonSchema)` to create a new message.
 */
export const PersonSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_person, 0);

/**
 * Describes the message carmen.IdentityDocument.
 * Use `create(IdentityDocumentSchema)` to create a new message.
 */
export const IdentityDocumentSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_person, 1);

/**
 * Describes the message carmen.MedicalCondition.
 * Use `create(MedicalConditionSchema)` to create a new message.
 */
export const MedicalConditionSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_person, 2);

/**
 * Describes the enum carmen.Gender.
 */
export const GenderSchema = /*@__PURE__*/
  enumDesc(file_proto_model_entity_person, 0);

/**
 * @generated from enum carmen.Gender
 */
export const Gender = /*@__PURE__*/
  tsEnum(GenderSchema);

/**
 * Describes the enum carmen.IdentityDocumentType.
 */
export const IdentityDocumentTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_entity_person, 1);

/**
 * @generated from enum carmen.IdentityDocumentType
 */
export const IdentityDocumentType = /*@__PURE__*/
  tsEnum(IdentityDocumentTypeSchema);

/**
 * Describes the enum carmen.AccessibilityNeed.
 */
export const AccessibilityNeedSchema = /*@__PURE__*/
  enumDesc(file_proto_model_entity_person, 2);

/**
 * Universal accessibility requirements
 *
 * @generated from enum carmen.AccessibilityNeed
 */
export const AccessibilityNeed = /*@__PURE__*/
  tsEnum(AccessibilityNeedSchema);

